export const CampaignType = {
  ROULETTE: 'ROULETTE',
  WORLD_CUP: 'WORLD_CUP'
} as const;

export type CampaignType = (typeof CampaignType)[keyof typeof CampaignType];

export const CAMPAIGN_TYPE_LABELS: Record<CampaignType, string> = {
  ROULETTE: 'Roleta',
  WORLD_CUP: 'Copa do Mundo'
};

export enum CampaignRouletteStatus {
  ATIVA = 'ATIVA',
  INATIVA = 'INATIVA',
  AGENDADA = 'AGENDADA',
  ENCERRADA = 'ENCERRADA'
}

export enum CampaignRouletteSortBy {
  START_DATE = 'startDate',
  CAMPAIGN_NAME = 'campaignName',
  END_DATE = 'endDate',
  CREATED_AT = 'createdAt',
  STATUS = 'status'
}

export interface ICampaignRoulette {
  id: number;
  idCapa?: number;
  nickname: string;
  startDate: string;
  endDate: string;
  status: CampaignRouletteStatus;
  campaignType: CampaignType;
  stores: IStore[];
  allStoresSelected?: boolean;
  regulations?: string;
  hasRegulationFile: boolean;
  hasBanner3x4: boolean;
  hasBanner16x9: boolean;
  probabilities: IProbability[];
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  linkedCampaignId?: number | null;
  linkedCampaignName?: string | null;
}

export interface IStore {
  id?: number;
  storeCode: string;
  storeName: string;
  nickname: string;
}

export interface IProbability {
  prob: number;
  prizes: number[];
}

export interface IPrize {
  id?: number;
  descricao: string;
  probabilidade: number;
  quantidade: number;
}

export interface ICampaignRouletteParams {
  meta: {
    page: number;
    perPage?: number;
  };
  search?: string;
  status?: string;
  orderBy?: string;
  campaignName?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: CampaignRouletteSortBy;
  sortOrder?: 'ASC' | 'DESC';
  includeDeleted?: boolean;
  campaignType?: CampaignType;
}

export interface ICreateCampaignRoulette {
  campaignName: string;
  startDate: string;
  endDate: string;
  stores: IStore[];
  probabilities: IProbability[];
  regulations?: File;
  banner3x4?: File;
  banner16x9?: File;
  allStoresSelected?: boolean;
  campaignType?: CampaignType;
  linkedCampaignId?: number | null;
}

export interface IUpdateCampaignRoulette {
  campaignName?: string;
  startDate?: string;
  endDate?: string;
  stores?: IStore[];
  probabilities?: IProbability[];
  regulations?: File;
  banner3x4?: File;
  banner16x9?: File;
  allStoresSelected?: boolean;
  campaignType?: CampaignType;
  linkedCampaignId?: number | null;
}

export interface ICampaignRouletteFilters {
  search?: string;
  status?: string;
  period?: string;
  periodStart?: string;
  periodEnd?: string;
  campaignType?: CampaignType;
  order?: {
    [key: string]: string;
  };
  meta?: {
    page?: number;
    perPage?: number;
  };
}

export const DEFAULT_PROBABILITIES: IProbability[] = [
  { prob: 0.17, prizes: [50] },
  { prob: 0.11, prizes: [40] },
  { prob: 5.75, prizes: [20] },
  { prob: 31.91, prizes: [10] },
  { prob: 62.05, prizes: [5] },
  { prob: 0.00, prizes: [3] }
];
